"use strict";
/* eslint-disable default-case */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.translateUItoBlang = exports.translateBlangToUI = exports.getAvailableOperators = exports.getTheInputType = exports.getInputValue = exports.isNum = exports.allOperators = exports.availableBooleanValue = void 0;
var i18next_1 = require("i18next");
var regexValidator_1 = require("@/react-app/common/services/regexValidator");
var TRANSLATE_UI_TO_BLANG_ERRORS = {
    TEXT: {
        CONTAINS_DOUBLE_QUOTE: (0, i18next_1.t)('AUTOMATION.DECISION_RULES.ERROR.DOUBLE_QUOTE'),
        EMPTY: (0, i18next_1.t)('AUTOMATION.DECISION_RULES.ERROR.EMPTY_NOT_ALLOW'),
    },
};
exports.availableBooleanValue = [
    { id: 'true', label: 'True' },
    { id: 'false', label: 'False' },
];
//   //define operators
var textareaOperators = [
    { id: 'CONTAINS', label: 'Contains' },
    { id: 'NOT CONTAINS', label: 'Not contains' },
];
var equalOperators = [
    { id: 'EQUALS', label: 'Equals' },
    { id: 'NOT EQUALS', label: 'Not equals' },
];
var listOperators = [
    { id: 'CONTAINS LIST', label: 'Contains list' },
    { id: 'NOT CONTAINS LIST', label: 'Not contains list' },
];
var confusableListOperators = [{ id: 'MATCH LIST', label: 'Matches confusable' }];
var betweenOperators = [
    { id: 'BETWEEN', label: 'Between' },
    { id: 'NOT BETWEEN', label: 'Not between' },
];
var numOperators = [
    { id: '<=', label: 'Less than or equal' },
    { id: '<', label: 'Less than' },
    { id: '>=', label: 'Greater than or equal' },
    { id: '>', label: 'Greater than' },
];
var existsOperators = [
    { id: 'EXISTS', label: 'Exists' },
    { id: 'NOT EXISTS', label: 'Not exists' },
];
exports.allOperators = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(textareaOperators), false), __read(listOperators), false), __read(equalOperators), false), __read(betweenOperators), false), __read(numOperators), false), __read(existsOperators), false), __read(confusableListOperators), false);
var isNum = function (n) { return !Number.isNaN(parseFloat(n)) && Number.isFinite(n); };
exports.isNum = isNum;
//   /**
//    * return data for the value input field, the format of the data depends on the input type
//    * @param value could be different data type depends on the type of input
//    * @param {String} type of input
//    */
var getInputValue = function (value, type) {
    var inputValue;
    switch (type) {
        case 'regex':
        case 'string':
            inputValue = { text: value };
            break;
        case 'dictionary':
            inputValue = { selectedList: [value] };
            break;
        case 'integer':
            inputValue = { number: Number(value) };
            break;
        case 'integer2':
            inputValue = { number1: Number(value[0]), number2: Number(value[1]) };
            break;
        case 'boolean':
            inputValue = {
                selectedBoolean: exports.availableBooleanValue.find(function (item) { return item.id === value.toString().toLowerCase(); }),
            };
            break;
    }
    return inputValue;
};
exports.getInputValue = getInputValue;
//   //check is selectOperator inside the operaterGroup
var operatorInGroup = function (selectOperator, operatorGroup) {
    return operatorGroup.some(function (operator) { return (operator === null || operator === void 0 ? void 0 : operator.id) === (selectOperator === null || selectOperator === void 0 ? void 0 : selectOperator.id); });
};
//   //get the input type will decide which type of the input it is, and what form of the value input field will show
var getTheInputType = function (selectedField, selectedOperator) {
    // EXIST and NOT EXIST operator does not have value an input value
    if (operatorInGroup(selectedOperator, existsOperators)) {
        return;
    }
    if (selectedField) {
        var fieldType = selectedField.type;
        if (!!fieldType && !!selectedOperator) {
            switch (fieldType) {
                case 'STRING':
                    if (operatorInGroup(selectedOperator, confusableListOperators)) {
                        return 'CONFUSABLE';
                    }
                    if (operatorInGroup(selectedOperator, listOperators)) {
                        return 'LIST';
                    }
                    return 'TEXT';
                case 'NUM':
                    if (operatorInGroup(selectedOperator, betweenOperators))
                        return 'BETWEEN';
                    return 'NUM';
                case 'BOOLEAN':
                    return 'BOOLEAN';
            }
        }
    }
};
exports.getTheInputType = getTheInputType;
var getAvailableOperators = function (fieldType) {
    var availableOperators = [];
    switch (fieldType) {
        case 'STRING':
            availableOperators = __spreadArray(__spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(textareaOperators), false), __read(listOperators), false), __read(equalOperators), false), __read(existsOperators), false), __read(confusableListOperators), false);
            break;
        case 'NUM':
            availableOperators = __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(equalOperators), false), __read(betweenOperators), false), __read(numOperators), false), __read(existsOperators), false);
            break;
        case 'BOOLEAN':
            availableOperators = __spreadArray(__spreadArray([], __read(equalOperators), false), __read(existsOperators), false);
            break;
    }
    return availableOperators;
};
exports.getAvailableOperators = getAvailableOperators;
//   /**
//    * translate blang to UI
//    * @param {Object} args  e.g. { field: { value: 'price' }, operator: 'EQUALS', value: { value: 100, type: 'integer' } }
//    * @param {String} domain  e.g. "your-domain.com"
//    */
var translateBlangToUI = function (ruleItem, availableField) {
    var valueArg;
    var typeArg;
    var operatorArg = ruleItem.sourceData.operator;
    if (Array.isArray(ruleItem.sourceData.value)) {
        valueArg = [ruleItem.sourceData.value[0].value, ruleItem.sourceData.value[1].value];
        typeArg = 'integer2';
    }
    else {
        valueArg = ruleItem.sourceData.value.value;
        typeArg = ruleItem.sourceData.value.type;
        if (typeArg === 'dictionary') {
            operatorArg += ' LIST';
        }
    }
    var field = availableField.find(function (item) { return ruleItem.sourceData.field.value === item.id; });
    var operator = exports.allOperators.find(function (item) { return operatorArg === item.id; });
    var value = (0, exports.getInputValue)(valueArg, typeArg);
    return { field: field, operator: operator, value: value };
};
exports.translateBlangToUI = translateBlangToUI;
//   /**
//    * translate UI to blang expression
//    * @param {Object} selectedField   e.g. {id: "price", label: "Price", type: "NUM"}
//    * @param {Object} selectedOperator  e.g. {id: "BETWEEN", label: "Between"}
//    * @param {Object} inputValue e.g. {number1: 434, number2: 432432, selectedList: undefined}
//    * @param {String} inputType  e.g. "BETWEEN"
//    */
var translateUItoBlang = function (selectedField, selectedOperator, inputValue, inputType) {
    var operator = '';
    var field = '';
    var value;
    var result = null;
    var errors = [];
    if (!!selectedOperator && !!selectedOperator.id)
        operator = selectedOperator.id.replace(' LIST', '');
    if (!!selectedField && selectedField.id)
        field = selectedField.id;
    switch (inputType) {
        case 'TEXT':
            value = translateTextToBlang(errors, inputValue.text);
            break;
        case 'LIST':
        case 'CONFUSABLE':
            value = translateListToBlang(errors, inputValue.selectedList);
            break;
        case 'NUM':
            value = inputValue.number;
            break;
        case 'BETWEEN':
            value = translateBetweenValueToBlang(errors, inputValue.number1, inputValue.number2);
            break;
        case 'BOOLEAN':
            value = translateBooleanValueToBlang(errors, inputValue.selectedBoolean);
            break;
    }
    if (!!field && !!operator && (!!value || value === 0))
        result = "$".concat(field, " ").concat(operator, " ").concat(value);
    if (operator === 'EXISTS') {
        result = "EXISTS ($".concat(field, ")");
    }
    if (operator === 'NOT EXISTS') {
        result = "NOT EXISTS ($".concat(field, ")");
    }
    if (errors.length > 0) {
        result = null;
    }
    return {
        expression: result,
        errors: errors,
    };
};
exports.translateUItoBlang = translateUItoBlang;
var translateBetweenValueToBlang = function (errors, num1, num2) {
    if (!num1 || !num2) {
        errors.push(TRANSLATE_UI_TO_BLANG_ERRORS.TEXT.EMPTY);
        return '';
    }
    if ((0, exports.isNum)(num1) && (0, exports.isNum)(num2)) {
        return "".concat(num1.toString(), "-").concat(num2.toString());
    }
    return '';
};
var translateBooleanValueToBlang = function (erros, value) {
    if (!value) {
        erros.push(TRANSLATE_UI_TO_BLANG_ERRORS.TEXT.EMPTY);
        return;
    }
    if (value.id)
        return value.id;
    return '';
};
var translateListToBlang = function (errors, value) {
    if (!value) {
        errors.push(TRANSLATE_UI_TO_BLANG_ERRORS.TEXT.EMPTY);
        return '';
    }
    if (value.length > 0)
        return "@".concat(value[0]);
    return '';
};
var translateTextToBlang = function (errors, text) {
    var value = text;
    if (!text) {
        errors.push(TRANSLATE_UI_TO_BLANG_ERRORS.TEXT.EMPTY);
        return value;
    }
    if ((0, regexValidator_1.isRegExp)(text)) {
        return value;
    }
    if (text.indexOf('"') !== -1) {
        errors.push(TRANSLATE_UI_TO_BLANG_ERRORS.TEXT.CONTAINS_DOUBLE_QUOTE);
    }
    value = "\"".concat(text, "\"");
    return value;
};
